import Stack from "@mui/material/Stack";
import PageTitle from "components/layout/PageTitle";
import ExternalRecruitersManagementContent from "features/external-recruiters/ExternalRecruitersManagementContent";

const ExternalRecruitersManagement = () => (
    <Stack direction="column" px="20px" py="10px" spacing={2}>
        <PageTitle title="External Recruiters Management" />
        <ExternalRecruitersManagementContent />
    </Stack>
);

export default ExternalRecruitersManagement;
